export default (function (siteVariables) {
  return {
    avatarBorderColor: siteVariables.colors.white,
    avatarBorderWidth: 2,
    statusBorderColor: siteVariables.colors.black
  };
});